module.exports = __webpack_public_path__ + "static/media/sword.3131b646.png";